export default {
  'language.usd': 'الدولار',
  'language.eur': 'اليورو',
  'language.rub': 'الروبل',
  'language.yen': 'الين',
  'language.german': 'Deutsche',
  'language.italian': 'Italiano',
  'language.arabic': 'عربی',
  'language.french': 'Français',
  'language.spanish': 'Español',
  'language.russian': 'русский',
  'language.english': 'English',
  'language.iran': 'فارسی',
  'language.rial': 'الريال',
  'component.select': 'اختر',
  'form.requierd': 'مطلوب',
  'form.isshort': 'قصير جداً',
  'form.islong': 'طويل جداً',
  'form.invalid': 'غير صالح',
  'form.number': 'يجب أن يكون رقمًا',
  'alert.info': 'معلومات',
  'alert.warning': 'تحذير',
  'alert.error': 'خطأ',
  'alert.notitle': ' ',
  'alert.success': 'نجاح',
  'errorBoundary.oops': 'عفوًا!!',
  'errorBoundary.weSearched': 'لم يتم العثور على الصفحة المطلوبة.',
  'errorBoundary.backToHome': 'العودة إلى الصفحة الرئيسية',
  'error.receiveerror': 'خطأ في استلام المعلومات',
  NextStep: 'الخطوة التالية',
  Previous: 'السابق',
  FirstName: 'الاسم الأول',
  LastName: 'اسم العائلة',
  BirthDate: 'تاريخ الميلاد',
  NationalCode: 'الرقم الوطني',
  Yes: 'نعم',
  No: 'لا',
  Jalali: 'جلالي',
  Miladi: 'ميلادي',
  Hijri: 'هجري',
  'faq.faq': 'الأسئلة الشائعة',
  'faq.firstquestion': 'ما هي مهمة مجموعة تريبسي؟',
  'faq.firstanswer':
    'مهمتنا هي "تسهيل القيام بالأعمال في أي مكان." بدأ مؤسسونا شركتنا لدعم الشركات الصغيرة، مؤمنين بأن الإنترنت سيساعد في تعميم الفرص من خلال تمكين الشركات الصغيرة من الاستفادة من الابتكار والتكنولوجيا للنمو والتنافس بشكل أفضل في الاقتصادات المحلية والعالمية. نؤمن بأن التركيز على احتياجات العملاء وحل مشاكلهم - سواء كانوا عملاءً أفرادًا أو تجارًا أو شركات - في نهاية المطاف سيؤدي إلى أفضل نتيجة لأعمالنا.',
  'faq.secendquestion': 'متى تأسست مجموعة تريبسي؟',
  'faq.secendanswer':
    'تأسست مجموعة تريبسي في عام 2022 من قبل 18 شخصًا بقيادة مهدي عبداللهي مهر، بدأت كسوق جملة عبر الإنترنت للمصدرين الصغار في إيران ورجال الأعمال للوصول إلى المشترين العالميين.',
  'faq.thirdquestion': 'أين تقع مكاتب مجموعة تريبسي؟',
  'faq.thirdanswer':
    'نحن نحتفظ بمكاتب في العديد من البلدان والمناطق، بما في ذلك الصين الرئيسية وهونغ كونغ وسنغافورة والولايات المتحدة. بالإضافة إلى ذلك، نحتفظ بمراكز بيانات في عدد من البلدان بما في ذلك الصين وإندونيسيا وماليزيا وأستراليا وسنغافورة والإمارات العربية المتحدة وألمانيا والمملكة المتحدة واليابان والولايات المتحدة.',
};
